import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { grey, red, white } from "../../styles/variables";

const { spacing } = theme;

export const dialog = css`
  .MuiDialog-paper {
    background-color: transparent;
    box-shadow: none;
  }
`;

export const card = css`
  box-shadow: none;
`;

export const cardHeader = css`
  padding: ${spacing(2.5, 2.5, 0)};

  .MuiTypography-root {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const cardContent = css`
  padding: ${spacing(2, 2.5)};
`;

export const section = css`
  display: flex;
  align-items: center;
`;

export const inputLabel = css`
  font-size: 12px;
  margin-bottom: ${spacing(2)}px;
`;

export const input = css`
  input::placeholder {
    font-size: 14px;
    color: ${grey};
    opacity: 1;
  }
`;

export const exclamationIcon = css`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${red};
  color: ${white};
  vertical-align: middle;
`;

export const actions = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(1.5)}px;
`;

export const button = css`
  width: 170px;
  height: 40px;
  margin-right: ${spacing(1)}px;

  &:last-of-type {
    margin-right: 0;
  }
`;
